import { ReactElement, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IScrollToTop {
  children: ReactElement;
}

const ScrollToTop = ({ children }: IScrollToTop): ReactElement => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
};

export default ScrollToTop;
